import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

export default function BottomSheet({ open, onClose, children, title, showHeader = true }) {
  const [show, setShow] = useState(open);

  useEffect(() => {
        if (open) setShow(true);
    else {
      // small delay for slide-down animation
      setTimeout(() => setShow(false), 200);
    }
  }, [open]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose(); // Call the function to dismiss the component
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]); // Re-run effect if onClose changes

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/40 transition-opacity duration-200
          ${open ? "opacity-100" : "opacity-0"}
        `}
        onClick={onClose} // dismiss when clicked outside
      />

      {/* Bottom Sheet */}
      <div
        className={`
          bg-backdrop w-full md:w-[50%] lg:w-[25rem] max-h-[80vh] rounded-t-2xl shadow-lg
          transform transition-transform duration-300 sm:translate-x-0 md:translate-x-36
          ${show ? "sm:translate-y-0 " : "translate-y-full"}
        `}
      >
        {showHeader && (
          <>
            {/* Header with title and close button */}
            <div className="border-b ">
              <div className="flex justify-between items-center mb-4 px-5 pt-5">
                <h2 className="text-lg font-semibold">{title}</h2>
                <FontAwesomeIcon icon={faClose} size="xl" className="cursor-pointer" onClick={onClose} />
              </div>
            </div>
          </>
        )}

        {/* Content */}
        <div className="overflow-y-auto no-scrollbar max-h-[70vh] p-5">{children}</div>
      </div>
    </div>
  );
}
